import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import PaymentMethodApiService, { PaymentMethod } from '@/services/paymentMethodApiService';
import { submitCompleteBooking, BookingCompleteData } from '@/services/bookingService';
import { getClientProfile } from '@/services/clientProfile';
import authService from '@/services/authService';

const FALLBACK_PAYMENT_METHODS: PaymentMethod[] = [
  {
    id: 1,
    code: 'qris',
    name: 'QRIS',
    provider: 'xendit',
    logo: null,
    description: 'Semua e-wallet & m-banking',
    instructions: null,
    customer_fee_type: 'none',
    customer_fee_amount: 0,
    customer_fee_percentage: 0,
    fee_calculation: 'none',
    min_amount: 1000,
    max_amount: 10000000,
    processing_time: 'Instant',
    requires_authentication: false,
    category: {
      id: 1,
      name: 'Instan',
      slug: 'qr-code',
      description: null,
      icon: 'mdi:qrcode',
      color_code: '#000000',
      sort_order: 1,
    },
    sort_order: 1,
  },
  {
    id: 2,
    code: 'bca_va',
    name: 'BCA Virtual Account',
    provider: 'xendit',
    logo: null,
    description: 'Verifikasi otomatis',
    instructions: null,
    customer_fee_type: 'fixed',
    customer_fee_amount: 4000,
    customer_fee_percentage: 0,
    fee_calculation: 'fixed',
    min_amount: 10000,
    max_amount: 50000000,
    processing_time: 'Instant',
    requires_authentication: false,
    category: {
      id: 2,
      name: 'Virtual Account',
      slug: 'virtual-account',
      description: null,
      icon: 'mdi:bank-outline',
      color_code: '#2563EB',
      sort_order: 2,
    },
    sort_order: 2,
  },
  {
    id: 3,
    code: 'bni_va',
    name: 'BNI Virtual Account',
    provider: 'xendit',
    logo: null,
    description: 'Verifikasi otomatis',
    instructions: null,
    customer_fee_type: 'fixed',
    customer_fee_amount: 4000,
    customer_fee_percentage: 0,
    fee_calculation: 'fixed',
    min_amount: 10000,
    max_amount: 50000000,
    processing_time: 'Instant',
    requires_authentication: false,
    category: {
      id: 2,
      name: 'Virtual Account',
      slug: 'virtual-account',
      description: null,
      icon: 'mdi:bank-outline',
      color_code: '#F97316',
      sort_order: 3,
    },
    sort_order: 3,
  },
  {
    id: 4,
    code: 'mandiri_va',
    name: 'Mandiri Virtual Account',
    provider: 'xendit',
    logo: null,
    description: 'Verifikasi otomatis',
    instructions: null,
    customer_fee_type: 'fixed',
    customer_fee_amount: 4000,
    customer_fee_percentage: 0,
    fee_calculation: 'fixed',
    min_amount: 10000,
    max_amount: 50000000,
    processing_time: 'Instant',
    requires_authentication: false,
    category: {
      id: 2,
      name: 'Virtual Account',
      slug: 'virtual-account',
      description: null,
      icon: 'mdi:bank-outline',
      color_code: '#1E293B',
      sort_order: 4,
    },
    sort_order: 4,
  },
  {
    id: 5,
    code: 'bri_va',
    name: 'BRI Virtual Account',
    provider: 'xendit',
    logo: null,
    description: 'Verifikasi otomatis',
    instructions: null,
    customer_fee_type: 'fixed',
    customer_fee_amount: 4000,
    customer_fee_percentage: 0,
    fee_calculation: 'fixed',
    min_amount: 10000,
    max_amount: 50000000,
    processing_time: 'Instant',
    requires_authentication: false,
    category: {
      id: 2,
      name: 'Virtual Account',
      slug: 'virtual-account',
      description: null,
      icon: 'mdi:bank-outline',
      color_code: '#1D4ED8',
      sort_order: 5,
    },
    sort_order: 5,
  },
  {
    id: 6,
    code: 'gopay',
    name: 'GoPay',
    provider: 'xendit',
    logo: null,
    description: 'Saldo GoPay',
    instructions: null,
    customer_fee_type: 'percentage',
    customer_fee_amount: 0,
    customer_fee_percentage: 1.5,
    fee_calculation: 'percentage',
    min_amount: 1000,
    max_amount: 10000000,
    processing_time: 'Instant',
    requires_authentication: false,
    category: {
      id: 3,
      name: 'E-wallet',
      slug: 'e-wallet',
      description: null,
      icon: 'mdi:wallet-outline',
      color_code: '#06B6D4',
      sort_order: 6,
    },
    sort_order: 6,
  },
  {
    id: 7,
    code: 'ovo',
    name: 'OVO',
    provider: 'xendit',
    logo: null,
    description: 'Saldo OVO',
    instructions: null,
    customer_fee_type: 'percentage',
    customer_fee_amount: 0,
    customer_fee_percentage: 1.5,
    fee_calculation: 'percentage',
    min_amount: 1000,
    max_amount: 10000000,
    processing_time: 'Instant',
    requires_authentication: false,
    category: {
      id: 3,
      name: 'E-wallet',
      slug: 'e-wallet',
      description: null,
      icon: 'mdi:wallet-outline',
      color_code: '#7E22CE',
      sort_order: 7,
    },
    sort_order: 7,
  },
  {
    id: 8,
    code: 'dana',
    name: 'DANA',
    provider: 'xendit',
    logo: null,
    description: 'Saldo DANA',
    instructions: null,
    customer_fee_type: 'percentage',
    customer_fee_amount: 0,
    customer_fee_percentage: 1.5,
    fee_calculation: 'percentage',
    min_amount: 1000,
    max_amount: 10000000,
    processing_time: 'Instant',
    requires_authentication: false,
    category: {
      id: 3,
      name: 'E-wallet',
      slug: 'e-wallet',
      description: null,
      icon: 'mdi:wallet-outline',
      color_code: '#3B82F6',
      sort_order: 8,
    },
    sort_order: 8,
  },
];

const formatIndonesianDate = (isoDateStr: string): string => {
  if (!isoDateStr) return '07 Agustus 2026';
  try {
    const parts = isoDateStr.split('-');
    if (parts.length === 3) {
      const year = parts[0];
      const monthIdx = parseInt(parts[1], 10) - 1;
      const day = parts[2];
      const monthNames = [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember',
      ];
      return `${day} ${monthNames[monthIdx] || 'Agustus'} ${year}`;
    }
  } catch (e) {
    // ignore
  }
  return isoDateStr;
};

export const ClientFieldPaymentMethodPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {};

  // Extract booking data from router state with fallbacks
  const arenaSlug = state.arena?.slug || 'arena-hk99';
  const arenaName = state.arena?.name || 'HK 99 Mini Soccer';
  const fieldSlug = state.field?.slug || 'lapangan-a';
  const fieldName = state.field?.name || 'Lapangan A · Sintetis';
  const rawDate = state.date || '2026-08-07';
  const formattedDate = formatIndonesianDate(rawDate);

  const timeSlots: string[] = state.timeSlots || ['16.00'];
  const durationText = `${timeSlots[0]} (${timeSlots.length} jam)`;
  const sessionFee = state.totalPrice || 180000;

  // Customer Form Data (Direct input without login requirement)
  const [customerName, setCustomerName] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');

  // Dynamic Payment Methods list from API or fallback
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethod[]>(FALLBACK_PAYMENT_METHODS);
  const [isLoadingMethods, setIsLoadingMethods] = useState<boolean>(true);
  const [selectedMethodCode, setSelectedMethodCode] = useState<string>('qris');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formError, setFormError] = useState<string | null>(null);

  // Fetch payment methods from API if available
  useEffect(() => {
    const fetchMethods = async () => {
      try {
        setIsLoadingMethods(true);
        const res = await PaymentMethodApiService.getPaymentMethods();
        if (Array.isArray(res) && res.length > 0) {
          // Filter out 'cash' category per sporto.id PaymentPage.tsx
          const filtered = res.filter((m) => m.category?.slug !== 'cash');
          setPaymentMethods(filtered);
          if (filtered.length > 0) {
            setSelectedMethodCode(filtered[0].code);
          }
        }
      } catch (err) {
        console.error('Failed to load payment methods:', err);
      } finally {
        setIsLoadingMethods(false);
      }
    };

    fetchMethods();
  }, []);

  // Fill customer data from profile API (/client/profile or /auth/app-me)
  useEffect(() => {
    const fetchCustomerProfile = async () => {
      try {
        const res = await getClientProfile();
        if (res && res.success && res.data) {
          if (res.data.name) setCustomerName(res.data.name);
          if (res.data.email) setCustomerEmail(res.data.email);
          if (res.data.phone) setCustomerPhone(res.data.phone);
          return;
        }
      } catch (e) {
        // Fallback to authService.me()
      }

      try {
        const meData = await authService.me();
        if (meData) {
          if (meData.name) setCustomerName(meData.name);
          if (meData.email) setCustomerEmail(meData.email);
        }
      } catch (e) {
        // ignore
      }
    };

    fetchCustomerProfile();
  }, []);

  const selectedMethod =
    paymentMethods.find((m) => m.code === selectedMethodCode) || paymentMethods[0];

  // Dynamic Fee calculation using PaymentMethodApiService.calculateCustomerFee
  const adminFee = PaymentMethodApiService.calculateCustomerFee(selectedMethod, sessionFee);
  const grandTotal = sessionFee + adminFee;

  const handleProcessPayment = async () => {
    if (!customerName.trim() || !customerEmail.trim()) {
      setFormError('Mohon lengkapi Nama dan Email Pemesan');
      return;
    }
    setFormError(null);
    setIsSubmitting(true);

    try {
      // Extract real slots array from router state
      const selectedSlotsFromState: any[] = Array.isArray(state.selectedSlots) && state.selectedSlots.length > 0
        ? state.selectedSlots
        : timeSlots.map((t: string) => ({
            public_id: `slot_${t.replace('.', '_')}`,
            start_time: t.includes(':') ? t : `${t.replace('.', ':')}:00`,
            end_time: `${String(parseInt(t, 10) + 1).padStart(2, '0')}:00:00`,
            duration_minutes: 60,
            day_of_week: 'monday',
          }));

      const formattedSlots = selectedSlotsFromState.map((slot: any) => ({
        day_of_week: slot.day_of_week || 'monday',
        duration_minutes: slot.duration_minutes || 60,
        end_time: slot.end_time || '17:00:00',
        public_id: slot.public_id,
        slot_id: slot.public_id,
        start_time: slot.start_time || '16:00:00',
      }));

      // Format payload for submitCompleteBooking
      const submissionData: BookingCompleteData = {
        arena_slug: arenaSlug,
        booking_date: rawDate,
        booking_id: state.bookingId || `BK-${Date.now()}`,
        email: customerEmail,
        field_slug: fieldSlug,
        name: customerName,
        notes: '-',
        payment_method: selectedMethod.code,
        payment_type: 'full',
        phone: customerPhone,
        product_items: [],
        selected_slots: formattedSlots,
        session_id: 'session_' + Date.now(),
      };

      const response = await submitCompleteBooking(submissionData);
      setIsSubmitting(false);

      if (response.success && response.data?.payment_info) {
        const invoiceNumber =
          response.data.payment_info.invoice_number ||
          response.data.payment_info.invoice_id ||
          '';

        navigate('/arena/checkout', {
          state: {
            invoiceNumber,
            arenaName,
            fieldName,
            formattedDate,
            durationText,
            selectedMethod: {
              id: selectedMethod.code,
              name: selectedMethod.name,
              category:
                selectedMethod.category?.slug === 'qr-code'
                  ? 'instant'
                  : selectedMethod.category?.slug === 'virtual-account'
                  ? 'va'
                  : 'ewallet',
              badgeText: selectedMethod.name.substring(0, 3).toUpperCase(),
              badgeBg: 'bg-black',
              badgeTextColor: 'text-white',
            },
            sessionFee,
            adminFee,
            grandTotal,
            customer: {
              name: customerName,
              email: customerEmail,
              phone: customerPhone,
            },
            paymentCheckoutPayload: response.data.payment_info.payment_checkout_payload,
            paymentInfo: response.data.payment_info,
          },
        });
      } else {
        setFormError(response.message || 'Gagal memproses pembayaran. Silakan coba lagi.');
      }
    } catch (error: any) {
      console.error('Error submitting booking:', error);
      setIsSubmitting(false);
      setFormError(
        error?.response?.data?.message ||
          error?.message ||
          'Terjadi kesalahan saat memproses booking ke server.'
      );
    }
  };

  // Helper function to render fee badge text (+Rp. XXX or Gratis)
  const renderFeeLabel = (method: PaymentMethod) => {
    const fee = PaymentMethodApiService.calculateCustomerFee(method, sessionFee);
    if (fee > 0) {
      return `+Rp. ${fee.toLocaleString('id-ID')}`;
    }
    return 'Gratis';
  };

  // Helper to render method badge icon
  const getBadgeStyle = (code: string) => {
    if (code.includes('bca')) return { bg: 'bg-blue-600', text: 'BCA' };
    if (code.includes('bni')) return { bg: 'bg-orange-500', text: 'BNI' };
    if (code.includes('mandiri')) return { bg: 'bg-slate-800', text: 'MDR' };
    if (code.includes('bri')) return { bg: 'bg-blue-700', text: 'BRI' };
    if (code.includes('gopay')) return { bg: 'bg-cyan-500', text: 'GO' };
    if (code.includes('ovo')) return { bg: 'bg-purple-700', text: 'OVO' };
    if (code.includes('dana')) return { bg: 'bg-blue-500', text: 'DN' };
    return { bg: 'bg-black', text: 'QR' };
  };

  return (
    <div className="bg-[#F8FAFC] min-h-screen pb-32 pt-2 px-4 max-w-md mx-auto space-y-4">
      {/* INFORMASI PEMESAN */}
      <div className="space-y-2">
        <h2 className="text-sm font-extrabold text-[#0E1726]">Informasi pemesan</h2>
        <div className="bg-white rounded-3xl p-4 sm:p-5 border border-gray-100 shadow-2xs space-y-3">
          {formError && (
            <div className="bg-red-50 text-red-600 text-xs p-3 rounded-2xl border border-red-100 font-semibold flex items-center gap-2">
              <Icon icon="ph:warning-circle-bold" className="w-4 h-4 shrink-0" />
              <span>{formError}</span>
            </div>
          )}

          <div className="space-y-1">
            <label className="text-xs font-bold text-gray-700">Nama Pemesan</label>
            <input
              type="text"
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
              placeholder="Nama Pemesan"
              className="w-full px-3.5 py-2.5 rounded-2xl border border-gray-200 text-xs font-semibold focus:outline-none focus:border-[#FC480D]"
            />
          </div>

          <div className="grid grid-cols-2 gap-2">
            <div className="space-y-1">
              <label className="text-xs font-bold text-gray-700">Email</label>
              <input
                type="email"
                value={customerEmail}
                onChange={(e) => setCustomerEmail(e.target.value)}
                placeholder="email@mail.com"
                className="w-full px-3.5 py-2.5 rounded-2xl border border-gray-200 text-xs font-semibold focus:outline-none focus:border-[#FC480D]"
              />
            </div>
            <div className="space-y-1">
              <label className="text-xs font-bold text-gray-700">No. WhatsApp</label>
              <input
                type="tel"
                value={customerPhone}
                onChange={(e) => setCustomerPhone(e.target.value)}
                placeholder="08123456789"
                className="w-full px-3.5 py-2.5 rounded-2xl border border-gray-200 text-xs font-semibold focus:outline-none focus:border-[#FC480D]"
              />
            </div>
          </div>
        </div>
      </div>

      {/* RINGKASAN PESANAN */}
      <div className="space-y-2">
        <h2 className="text-sm font-extrabold text-[#0E1726]">Ringkasan pesanan</h2>

        <div className="bg-white rounded-3xl p-4 sm:p-5 border border-gray-100 shadow-2xs space-y-3">
          {/* Header Field Info */}
          <div className="flex items-center gap-3">
            <img
              src="https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=200&auto=format&fit=crop&q=80"
              alt={arenaName}
              className="w-12 h-12 rounded-2xl object-cover bg-gray-100 shrink-0 border border-gray-100"
            />
            <div className="min-w-0 flex-1">
              <h3 className="text-sm font-extrabold text-[#0E1726] truncate">{arenaName}</h3>
              <p className="text-xs text-gray-400 font-semibold truncate mt-0.5">{fieldName}</p>
            </div>
          </div>

          {/* Details Table */}
          <div className="border-t border-b border-gray-100 py-3 space-y-2.5 text-xs">
            <div className="flex items-center justify-between">
              <span className="text-gray-400 font-medium">Tanggal</span>
              <span className="font-bold text-[#0E1726]">{formattedDate}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-gray-400 font-medium">Jam</span>
              <span className="font-bold text-[#0E1726]">{durationText}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-gray-400 font-medium">Biaya sesi</span>
              <span className="font-extrabold text-[#0E1726]">
                Rp. {sessionFee.toLocaleString('id-ID')}
              </span>
            </div>
          </div>

          {/* Edit Button */}
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="w-full text-center text-xs font-extrabold text-[#FC480D] hover:underline flex items-center justify-center gap-1.5 py-1 cursor-pointer"
          >
            <Icon icon="ph:pencil-simple-bold" className="w-3.5 h-3.5 text-[#FC480D]" />
            <span>Ubah pesanan</span>
          </button>
        </div>
      </div>

      {/* METODE PEMBAYARAN */}
      <div className="space-y-3 pt-1">
        <h2 className="text-sm font-extrabold text-[#0E1726]">Metode pembayaran</h2>

        {isLoadingMethods ? (
          <div className="bg-white rounded-3xl p-6 text-center text-xs font-semibold text-gray-400 border border-gray-100 shadow-2xs flex items-center justify-center gap-2">
            <div className="w-4 h-4 border-2 border-[#FC480D] border-t-transparent rounded-full animate-spin" />
            <span>Memuat metode pembayaran...</span>
          </div>
        ) : (
          <div className="bg-white rounded-3xl border border-gray-100 shadow-2xs divide-y divide-gray-100 overflow-hidden">
            {paymentMethods.map((method) => {
              const isSelected = selectedMethodCode === method.code;
              const feeLabel = renderFeeLabel(method);
              const badge = getBadgeStyle(method.code);

              return (
                <div
                  key={method.code || method.id}
                  onClick={() => setSelectedMethodCode(method.code)}
                  className={`p-3.5 flex items-center justify-between gap-3 cursor-pointer transition-colors ${
                    isSelected ? 'bg-orange-50/50' : 'hover:bg-gray-50/60'
                  }`}
                >
                  <div className="flex items-center gap-3 min-w-0 flex-1">
                    <div
                      className={`w-10 h-10 rounded-2xl ${badge.bg} text-white font-extrabold text-[11px] flex items-center justify-center shrink-0 shadow-2xs`}
                    >
                      {badge.text}
                    </div>
                    <div className="space-y-0.5 min-w-0">
                      <div className="text-xs font-extrabold text-[#0E1726] truncate">
                        {method.name}
                      </div>
                      <div className="text-[11px] text-gray-400 font-medium truncate">
                        {method.description || 'Verifikasi otomatis'}
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center gap-2.5 shrink-0">
                    <span
                      className={`text-xs font-extrabold ${
                        feeLabel === 'Gratis' ? 'text-emerald-600' : 'text-gray-500'
                      }`}
                    >
                      {feeLabel}
                    </span>
                    {isSelected ? (
                      <Icon
                        icon="ph:check-circle-fill"
                        className="w-5 h-5 text-[#FC480D] shrink-0"
                      />
                    ) : (
                      <div className="w-5 h-5 rounded-full border-2 border-gray-300 shrink-0" />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* TOTAL BREAKDOWN CARD */}
      <div className="bg-white rounded-3xl p-4 sm:p-5 border border-gray-100 shadow-2xs space-y-2.5 pt-3">
        <div className="flex items-center justify-between text-xs">
          <span className="text-gray-400 font-medium">Subtotal pesanan</span>
          <span className="font-bold text-[#0E1726]">
            Rp. {sessionFee.toLocaleString('id-ID')}
          </span>
        </div>
        <div className="flex items-center justify-between text-xs">
          <span className="text-gray-400 font-medium">Biaya layanan</span>
          <span
            className={`font-bold ${adminFee === 0 ? 'text-emerald-600' : 'text-[#0E1726]'}`}
          >
            {adminFee === 0 ? 'Gratis' : `+Rp. ${adminFee.toLocaleString('id-ID')}`}
          </span>
        </div>
        <hr className="border-gray-100" />
        <div className="flex items-center justify-between text-sm">
          <span className="font-extrabold text-[#0E1726]">Total bayar</span>
          <span className="font-extrabold text-[#FC480D] text-base">
            Rp. {grandTotal.toLocaleString('id-ID')}
          </span>
        </div>
      </div>

      {/* STICKY BOTTOM ACTION BAR */}
      <div className="fixed bottom-0 left-0 right-0 max-w-md mx-auto bg-white border-t border-gray-100 p-3.5 px-4 z-40 flex items-center justify-between gap-3 shadow-lg">
        <div className="space-y-0.5 min-w-0">
          <div className="text-[11px] font-semibold text-gray-400 truncate uppercase">
            {selectedMethod.name}
          </div>
          <div className="text-lg font-extrabold text-[#FC480D]">
            Rp. {grandTotal.toLocaleString('id-ID')}
          </div>
        </div>

        <button
          type="button"
          disabled={isSubmitting}
          onClick={handleProcessPayment}
          className="h-12 px-6 rounded-full bg-[#FC480D] hover:bg-[#D83B08] text-white text-xs font-extrabold flex items-center justify-center gap-2 transition-all shadow-md active:scale-98 cursor-pointer disabled:opacity-50 shrink-0"
        >
          {isSubmitting ? (
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
          ) : (
            <Icon icon="ph:shield-check-bold" className="w-4 h-4" />
          )}
          <span>{isSubmitting ? 'Memproses...' : 'Bayar Sekarang'}</span>
        </button>
      </div>
    </div>
  );
};
